import bg1 from '../assets/images/backgrounds/1.jpg';
import bg2 from '../assets/images/backgrounds/2.jpg';
import bg3 from '../assets/images/backgrounds/3.jpg';
import bg4 from '../assets/images/backgrounds/4.svg';
import bg5 from '../assets/images/backgrounds/5.svg';
import bg6 from '../assets/images/backgrounds/6.jpg';

export const wallpapers = [bg1, bg2, bg3, bg4, bg5, bg6];
